/* unplugin-vue-components disabled */import { render } from "./new-chat-v1.vue?vue&type=template&id=6190ac3d&scoped=true"
import script from "./new-chat-v1.vue?vue&type=script&lang=js"
export * from "./new-chat-v1.vue?vue&type=script&lang=js"

import "./new-chat-v1.vue?vue&type=style&index=0&id=6190ac3d&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6190ac3d"],['__file',"src/pages/new-chat/new-chat-v1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6190ac3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6190ac3d', __exports__)) {
    api.reload('6190ac3d', __exports__)
  }
  
  module.hot.accept("./new-chat-v1.vue?vue&type=template&id=6190ac3d&scoped=true", () => {
    api.rerender('6190ac3d', render)
  })

}


export default __exports__